/**
 * This store is used to control the 'My Account' sections of the application
 * This module will handle the filtering options
 * which will be applied to both tabs (journeys and products)
 * Further account movements can be filtered using the same data.
 *
 * The filters selected will collect ALL of the data for the selected range
 * The pagination will be used to show datasets of the whole collection
 *
 * EG:
 * from: 01/01/2024
 * to:   31/03/2024 (maximum of 3 months)
 *
 * Journeys: Total records of 1200 entries (assuming 300 journeys per month)
 * Products: Total records of 90 (assuming an average of 30 purchases per month)
 *
 * The records will be saved to the corresponding store
 * The corresponding component will be in charge of serving the
 * slices of the dataset - pagination / infintescroll (my preference)
 *
 * Possible filters from backend
 * :from,
 * :until,
 * :operator_id,
 * :bus_id,
 * :media_code,
 * :device_code,
 * :no_charge,
 * :media_type, []
 * :administrative_area_code,
 * :administrative_area_id,
 * :identifier,
 * :rut_passport,
 * :profile_code,
 * :type, []
 * :penalty_charged_transaction,
 * :tsc_client_transactions,
 * :account_client_transactions,
 * :client_travels_media_type,
 * :client_product_travels,
 * :expedition_code, []
 * :expired,
 * media_type_array: [], type_array: [], expedition_codes: []
 */
import './constants'

const today = moment()

export default {
  namespaced: true,
  filters: {
    state: {
      from: today.clone().subtract(3, 'month').format('YYYY-MM-DD'),
      until: today.format('YYYY-MM-DD'),
      paymentMethod: '',
      mediaType: ''
    },
    mutations: {
      setPaymentMethod(state, val) {
        state.paymentMethod = val
      },
      setMediaType(state, val) {
        state.mediaType = val
      },
      setFrom(state, newVal) {
        state.from = newVal
      },
      setUntil(state, newVal) {
        state.until = newVal
      },
      setDateRange(state, val) {
        // 1. PROTECCIÓN: Si el usuario limpia el datepicker, val es null
        if (!val) {
          state.from = ''
          state.until = ''

          return
        }

        // 2. Si hay valor, asignamos (aprovecha para usar el formato correcto)
        state.from = moment(val[0]).format('YYYY-MM-DD')
        state.until = moment(val[1]).format('YYYY-MM-DD')
      }
    },
    getters: {
      from: state => state.from,
      until: state => state.until,

      dateRange: state => [state.from, state.until],
      mediaType: state => state.mediaType,

      // paymentMethods(state, getters, rootState, rootGetters) {
      //   const trips = rootGetters['user/travels']() // Returns an array
      //   let methods = new Map()
      //   if(trips.length < 1) return methods
      //     methods.set('', {
      //         'id': '',
      //         'code': '',
      //         'name': '---'
      //     })
      //   trips.forEach((trip) => {
      //     let mediaType = rootGetters['getMediaType'](trip.media_type)
      //     methods.set(trip.media_code, mediaType)
      //   })
      //   console.log('Methods', methods)
      //   return methods
      // },

      paymentMethod: state => state.paymentMethod
    }

  }
}
